import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../../services/apiConfig";

const API_URL = `${API_BASE_URL}/api/rooms`;

export const fetchRooms = createAsyncThunk("rooms/fetchRooms", async () => {
  const response = await axios.get(API_URL);
  return response.data;
});

export const fetchAvailableRooms = createAsyncThunk(
  "rooms/fetchAvailableRooms",
  async ({ appointmentDate, appointmentTime, duration = 30, doctorId }) => {
    const response = await axios.get(`${API_URL}/available`, {
      params: { appointmentDate, appointmentTime, duration, doctorId },
    });
    return response.data;
  },
);

export const addRoom = createAsyncThunk("rooms/addRoom", async (roomData) => {
  const response = await axios.post(API_URL, roomData);
  return response.data;
});

export const updateRoomData = createAsyncThunk(
  "rooms/updateRoomData",
  async ({ id, roomData }) => {
    const response = await axios.put(`${API_URL}/${id}`, roomData);
    return response.data;
  },
);

export const removeRoom = createAsyncThunk("rooms/removeRoom", async (id) => {
  await axios.delete(`${API_URL}/${id}`);
  return id;
});

const roomSlice = createSlice({
  name: "rooms",
  initialState: {
    rooms: [],
    availableRooms: [],
    loading: false,
    availableLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRooms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload;
      })
      .addCase(fetchRooms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAvailableRooms.pending, (state) => {
        state.availableLoading = true;
      })
      .addCase(fetchAvailableRooms.fulfilled, (state, action) => {
        state.availableLoading = false;
        state.availableRooms = action.payload;
      })
      .addCase(fetchAvailableRooms.rejected, (state, action) => {
        state.availableLoading = false;
        state.error = action.error.message;
      })
      .addCase(addRoom.fulfilled, (state, action) => {
        state.rooms.push(action.payload);
        state.error = null;
      })
      .addCase(updateRoomData.fulfilled, (state, action) => {
        const index = state.rooms.findIndex(
          (r) => r.room_id === action.payload.room_id,
        );
        if (index !== -1) {
          state.rooms[index] = action.payload;
        }
      })
      .addCase(removeRoom.fulfilled, (state, action) => {
        state.rooms = state.rooms.filter((r) => r.room_id !== action.payload);
      });
  },
});

export default roomSlice.reducer;
